import React from "react";

const ShareAltLinkOutRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.25 2.75H4.75C3.64543 2.75 2.75 3.64543 2.75 4.75V15.25C2.75 16.3546 3.64543 17.25 4.75 17.25H15.25C16.3546 17.25 17.25 16.3546 17.25 15.25V12.75",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.25 7.25V2.75H12.75",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17 3L9.75 10.25",
  stroke: "currentColor",
  strokeWidth: 1.1,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(ShareAltLinkOutRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;